module.exports = __webpack_public_path__ + "static/media/images.3fe9845d.svg";